import { Route, Routes } from 'react-router-dom';
import BookPage from './pages/BookPage';
import BookCancelPage from './pages/BookCancelPage';
import BookRefPage from './pages/BookRefPage';

/**
 * Routes inside the /book basename.
 *
 * Hugo renders exactly one page here, /book/. Everything below it is a
 * `_redirects` SPA-fallback rewrite back to that page, and this is where the
 * real path gets read.
 *
 *   /book/                 the default booking type
 *   /book/<type>/          a named booking type, e.g. /book/intro-30/
 *   /book/ref/<token>/     one booking's own page, from a confirmation email
 *   /book/cancel/<token>/  the cancel link from a confirmation email
 *
 * `cancel/:token` and `ref/:token` are declared before `:slug` for readability.
 * React Router ranks static segments above dynamic ones regardless of order, so a
 * booking type could never be called "cancel" or "ref" and steal either route.
 */
export default function App() {
  return (
    <Routes>
      <Route path="/" element={<BookPage />} />
      <Route path="cancel/:token" element={<BookCancelPage />} />
      <Route path="ref/:token" element={<BookRefPage />} />
      <Route path=":slug" element={<BookPage />} />
      <Route path=":slug/*" element={<BookPage />} />
    </Routes>
  );
}
